import { CustomIconProps } from './index';

export const SelectIcon = ({ color }: CustomIconProps) => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle
                cx={12}
                cy={12}
                r={11}
                fill="#fff"
                stroke={color || 'black'}
                strokeWidth={2}
            />
            <path
                fill={color || 'black'}
                d="M11 6h2v2h-2zM16 11h2v2h-2zM11 16h2v2h-2zM6 11h2v2H6zM6 6h3v3H6zM6 15h3v3H6zM15 6h3v3h-3zM15 15h3v3h-3z"
            />
        </svg>
    );
};
